<bb-page-header [icon]="'pencil-square'" [title]="'CUSTOM_FIELDS' | translate">
	<ul class="tabs">
		<li>
			<a class="active">
				<i class="fa fa-film"></i> {{ 'MEDIACLIPS' | translate }}
			</a>
		</li>
	</ul>
</bb-page-header>

<div class="body-column">

	<div class="action-buttons">
		<a class="button" [routerLink]="['/publication/custom-field/mediaclip']"><i class="fa fa-plus"></i>
			<span class="short-label">{{ 'ADD_CUSTOM_FIELD' | translate }}</span>
		</a>
		<bb-info [contents]="'HELP.CUSTOM_FIELDS' | translate"></bb-info>
	</div>

	<bb-table-container cdkDropList (cdkDropListDropped)="reorder($event)">

		<bb-table-header>
			<bb-table-header-cell></bb-table-header-cell>
			<bb-table-header-cell>{{ 'LABEL' | translate }}</bb-table-header-cell>
			<bb-table-header-cell>{{ 'CODE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell>{{ 'TYPE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell>{{ 'OPTIONS' | translate }}</bb-table-header-cell>
			<bb-table-header-cell [hasPublicationFieldOrPermission]="'includeInStats'">{{ 'IN_STATS' | translate }}</bb-table-header-cell>
			<bb-table-header-cell>{{ 'MANDATORY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell>{{ 'VISIBLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell>{{ 'PUBLIC' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of customfields" [row]="row" (dblclick)="redirectToDetails(row)" cdkDrag cdkDragLockAxis="y">
			<bb-table-cell class="small"><i class="drag fa fa-bars"></i></bb-table-cell>
			<bb-table-cell class="overflow">{{ row.label }}</bb-table-cell>
			<bb-table-cell class="overflow">{{ row.name }}</bb-table-cell>
			<bb-table-cell class="small">
				<span *ngIf="row.itype === 'color'">{{ 'CUSTOM_FIELD_COLOR' | translate }}</span>
				<span *ngIf="row.type === 'date'">{{ 'CUSTOM_FIELD_DATE' | translate }}</span>
				<span *ngIf="row.itype === 'text'">{{ 'CUSTOM_FIELD_TEXT_AREA' | translate }}</span>
				<span *ngIf="row.itype === 'string'">{{ 'CUSTOM_FIELD_TEXT_FIELD' | translate }}</span>
				<span *ngIf="row.itype === 'number'">{{ 'CUSTOM_FIELD_INT_FIELD' | translate }}</span>
				<span *ngIf="row.type === 'relation' || row.type === 'relationlist'">{{ 'CUSTOM_FIELD_RELATION' | translate }}</span>
				<span *ngIf="row.itype === 'list'">{{ 'CUSTOM_FIELD_LIST' | translate }}</span>
				<span *ngIf="row.type === 'boolean'">{{ 'CUSTOM_FIELD_CHECKBOX' | translate }}</span>
				<span *ngIf="row.itype === 'richtext'">{{ 'CUSTOM_FIELD_RICH_TEXT' | translate }}</span>
			</bb-table-cell>
			<bb-table-cell class="overflow">{{ row.options | commaSeparatedProperty : 'label' }}</bb-table-cell>
			<bb-table-cell class="small centered" [hasPublicationFieldOrPermission]="'includeInStats'"><span *ngIf="row.includeInStats" class="fa fa-check"></span></bb-table-cell>
			<bb-table-cell class="small centered"><span *ngIf="row.priority === 'mandatory'" class="fa fa-check"></span></bb-table-cell>
			<bb-table-cell class="small centered"><span *ngIf="row.visible" class="fa fa-check"></span></bb-table-cell>
			<bb-table-cell class="small centered"><span *ngIf="row.public" class="fa fa-check"></span></bb-table-cell>
			<bb-table-cell class="small row_actions buttons" (click)="$event.stopPropagation()">
				<a class="button" [routerLink]="['/publication/custom-field/mediaclip', row.name]">
					<i class="fa fa-edit"></i>
				</a>
				<a class="button" (click)="deleteSingle(row)">
					<i class="fa fa-trash"></i>
				</a>
			</bb-table-cell>

		</bb-table-row>

	</bb-table-container>

	<div class="no-results" *ngIf="customfields && !customfields.length">{{ 'NO_CUSTOM_FIELDS_FOUND' | translate }}</div>

</div>